<template>
  <el-row class="bread">
    <el-col :span="11" class="left-box">
      <nav class="el-breadcrumb" aria-label="Breadcrumb">
        <span v-for="(bread, index) in breadList" :key="bread.url || bread.name" class="el-breadcrumb__item">
          <router-link v-if="bread.url" :to="bread.url" class="el-breadcrumb__inner">{{bread.name}}</router-link>
          <span v-else class="el-breadcrumb__inner" aria-current="page">{{bread.name}}</span>
          <i v-if="index < breadList.length - 1" class="el-breadcrumb__separator el-icon-arrow-right" aria-hidden="true"></i>
        </span>
        <slot name="v-left"></slot>
      </nav>
    </el-col>
    <el-col :span="13" align="right" class="right-box">
      <slot name="v-right"></slot>
    </el-col>
    <slot></slot>
  </el-row>
</template>

<script>
export default {
  name: 'Bread',

  data() {
    return {};
  },

  props: ['breadList'],
};
</script>

<style lang="scss">
  .bread {
    height: 40px;
    padding: 10px 1px;
    background: #fff;
    /*border-left: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;*/
    .el-breadcrumb {
      line-height: 20px;
      font-size: 12px;
      .el-breadcrumb__item:not(:last-child) {
        .el-breadcrumb__inner {
          /*color: #333;*/
          color: #777777;
          font-weight: 400;
        }
      }
      .el-breadcrumb__item:last-child {
        .el-breadcrumb__inner {
          /*color: #333;*/
          color: #777777;
        }
      }
    }
    .right-box {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/v-bread.vue